/**  Constant to mark each step in the analytics funnel */
export const CURRENT_STEP = 'Current Step';

/** Profile info */
export const QUOTATION_ID = 'Quotation Id';
export const CUSTOMER_EMAIL = 'Customer email';
export const CUSTOMER_PHONE = 'Customer phone';
export const CUSTOMER_NAME = 'Customer name';

/** Form Steps */
export const WELCOME_PAGE_STEP = 'Welcome Page Step';
export const DEDUCTIBLE_OPTION_STEP = 'Deductible Option Step';
export const VERIFY_QUOTATION_STEP = 'Verify Quotation Step';
export const CAR_INFORMATION_STEP = 'Car Information Step';
export const CAR_PHOTOS_STEP = 'Car Photos Step';
export const FINAL_SCREEN_STEP = 'Final Step';

/** Constants for welcome page step */
export const START_DATE = 'Start date';

/** Constant for verify quotation Step */
export const ISQUOTATION_CORRECT = 'Is quotation correct?';

/** Constants for car information step */
export const LICENSE_PLATE = 'License Plate';

/** Constants for final Screen Step */
export const END_DATE = 'Completion Date';
export const EMISSION_METHOD = 'Emission Method';

/** Emission forms steps */
export const WELCOME_EMISSION_PAGE_STEP = 'Welcome Emission Page Step';
export const CONTRACTOR_DATA_EMISSION_STEP = 'Contractor Data Emission Step';
export const EMISSION_CAR_INFORMATION_STEP = 'Emission Car Information Step';
export const PAYMENT_DATA_EMISSION_STEP = 'Payment Data Emission Step';
export const SUMMARY_EMISSION_STEP = 'Summary Emission Step';
export const FINAL_EMISSION_STEP = 'Final Emission Page Step';
export const UPSELLING_ENDORSEMENT = 'Upselling endorsement';

/** Emission flow properties */
export const EMISSION_BY = 'Emission by';
export const ORIGIN = 'Emission Origin';
export const LASTNAME = 'Customer Last Name Emission';
export const CUSTOMER_BIRTH_DATE = 'Customer Birth Date Emission';
export const EMAIL = 'Customer Email Emission';
export const PHONE = 'Customer Phone Emission';
export const FINANCING = 'Financing Method';
export const PAYER = 'Payer Type';
export const PAYMENT_METHOD = 'Payment Method';
export const CARD_TYPE = 'Card Type';
export const BANK_ISSUER = 'Bank Issuer';
export const PAYMENT_FREQUENCY = 'Payment Frequency';
export const PAY_DAY = 'Pay day';
export const SELECTED_PACKAGE = 'Selected Package';

/** Summary Properties */
export const AUTO_PX = 'AutoPx';
export const DEDUCTIBLE_OPTION = 'Deductible option';
export const CAR_BRAND = 'Car brand';
export const CAR_MODEL = 'Car model';
export const CAR_YEAR = 'Car year';
export const NEW_VEHICLE = 'Is new vehicle';
export const COLLECTIVE_NAME = 'Collective Name';
export const VALUE = 'Car value';
export const COVERAGE_TYPE = 'Coverage type';
export const PREMIUM = 'Premium';
export const SELECTED_ENDORSMENT = 'Selected endorsment';
export const ERROR_CODE = 'Error code';
export const ERROR_DESCRIPTION = 'Error description';
export const USER_EMAIL = 'User email';
export const USER_NAME = 'User name';
export const BROKER_LICENSE = 'Broker license';
